module.exports = __webpack_public_path__ + "img/headphoneIMGL4494_TP_V4.69c7ef2f.png";